import { h, Component } from 'preact';

import WithTooltip from 'components/tooltip/withTooltip';
import Help from 'components/icons/help';

export default class HelpTooltip extends Component {
	render(props) {
		return (
			<WithTooltip {...props} tooltip={props.children}>
				<Help height="16" />
			</WithTooltip>
		);
	}
}